import { render, staticRenderFns } from "./DeliveryInfoForm.vue?vue&type=template&id=448013fb&"
import script from "./DeliveryInfoForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports